<template>
  <main class="main">
    <div class="anim-wrap">
      <div class="mono-logo-container text-center">
        <img src="@/assets/logo_white.svg" alt="Traitstack" />
      </div>
      <div class="field-error" :class="{ toggled: error }">
        {{ errorMessage }}
      </div>
      <div id="authPanel" class="panel auth-panel">
        <div v-if="phase == 0">
          <h1 class="h2">Reset password</h1>
          <form action="javascript:void(0);">
            <input
              type="text"
              v-model="email"
              class="form-control"
              placeholder="Email address"
            />
            <button
              type="submit"
              @click="resetPassword"
              :class="{ active: loading, success: success }"
              class="btn btn-primary btn-auth btn-loader"
            >
              <span>Reset password</span>
            </button>
          </form>
          <div class="divider-text">
            <span>or</span>
          </div>
          <p class="auth-info">
            Go back to
            <router-link to="/sign-in">sign in</router-link>
          </p>
        </div>
        <div v-if="phase == 1">
          <h1 class="h2">Password reset link sent</h1>
          <p>
            Password reset link has been emailed to
          </p>
          <p>
            <b>{{ email }}</b
            >.
          </p>
          <p>Please check the email and follow instructions.</p>
          <p style="margin-top: 20px;">
            Go back to
            <router-link to="/sign-in">sign in</router-link>
          </p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
// FireBase
import firebase from "firebase/app";
import "firebase/functions";

export default {
  name: "resetpassword",
  components: {},
  data() {
    return {
      email: "",
      password: "",
      loading: false,
      error: false,
      errorMessage: "",
      success: false,
      phase: 0,
    };
  },
  methods: {
    resetPassword: function() {
      if (this.loading) {
        return;
      }
      this.loading = true;

      let resetPassword = firebase
        .functions()
        .httpsCallable("sendPasswordResetEmail");

      resetPassword({
        emailAddress: this.email,
      })
        .then(() => {
          this.loading = false;
          this.success = true;
          this.error = false;
          setTimeout(() => {
            this.phase = 1;
          }, 1000);
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorMessage = error.message;
          document.getElementById("authPanel").classList.remove("error");
          void document.getElementById("authPanel").offsetWidth;
          document.getElementById("authPanel").classList.add("error");
        });
    },
  },
};
</script>
